import { useMutation } from 'react-query';
import notify from '../../../../../../../shared/feedback/notifications';
import { Translate } from '../../../../../../../shared/LanguageService';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import ImageProcessingApi from '../../../api/ImageProcessingApi';

type DownloadImagesMutationArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

export function useDownloadImagesMutation({ orderId, user }: DownloadImagesMutationArgs) {
    let { logger } = useTelemetryContext();

    return useMutation(
        (imageIds: number[]) => ImageProcessingApi.downloadImageGroup(orderId, imageIds),
        {
            onMutate: () => {
                notify.success(Translate('image-processing/button-label/download-images/started'));
            },
            onError: (error) => {
                logger.logException(error, {
                    origin: 'ImageEditorImageProcessingPage.Mutation.downloadImageGroup',
                    userInfo: getUserInfo(user)
                });
                notify.failure(Translate('image-processing/button-label/download-images/error'));
            }
        }
    );
}
